import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import reduxThunk from 'redux-thunk';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import _ from 'lodash';
import rootReducer from '../reducers/reducers';

const configureStore = initialState => {
  const updatedState = _.isEmpty(sessionStorage.reduxState)
    ? initialState
    : JSON.parse(sessionStorage.reduxState);
  const middleWares =
    process.env.NODE_ENV === 'development'
      ? [reduxThunk, reduxImmutableStateInvariant()]
      : [reduxThunk];

  return createStore(
    rootReducer,
    updatedState,
    composeWithDevTools(applyMiddleware(...middleWares))
  );
};

export default configureStore;
